import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useHoverable } from "@gemini/core";
export const PhoneLink = (prop) => {
    const { boxProps, isHovered } = useHoverable();
    return (_jsx(Box, Object.assign({}, boxProps, { as: "button", typography: "typography.body.16.regularUnderlined", textAlign: "left", color: isHovered
            ? "color.content.interactive.hover"
            : "color.content.interactive.default", cursor: "pointer", borderStyle: "hidden", outlineStyle: "hidden", padding: 0, marginRight: "spacing.8", testId: prop === null || prop === void 0 ? void 0 : prop.testId, whiteSpace: "nowrap", children: prop.title })));
};
